<template>
    <MainTempComp
        ref="mainTempRef"
    >
        <template #header>
            <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :shortcuts="shortcuts"
                value-format="YYYY-MM-DD"
            >
            </el-date-picker>
            <span style="padding-left: 10px"></span>
            <el-button type="primary" @click="handleSearch">查询</el-button>
        </template>
        <template #main>
            <tableComp :tableData="data.tableData"></tableComp>
        </template>
    </MainTempComp>
    <add-edit-user
        ref="AddEditUserRef"
        :currentData="data.currentData"
    ></add-edit-user>
</template>

<script>
import { onMounted, provide, reactive, ref, watch } from "vue";
import tableComp from "./table.vue";
import { apiActualRevenue } from "@/api/requestApis.js";
import AddEditUser from "./children/add-edit-user.vue";

// 日期格式化工具
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export default {
    name: "userManage",
    components: {
        tableComp,
        AddEditUser,
    },
    setup() {
        const mainTempRef = ref(null);
        const AddEditUserRef = ref(null);
        const dateValue = ref([]); // 日期范围绑定

        // 表格数据
        const data = reactive({
            tableData: [],
            currentData: {},
        });

        // ✅ 核心：日期选择器快捷选项 → 今天、昨天、本周、本月、半年
        const shortcuts = [
            {
                text: "今天",
                value: () => {
                    const today = new Date();
                    return [today, today];
                },
            },
            {
                text: "昨天",
                value: () => {
                    const date = new Date();
                    date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
                    return [date, date];
                },
            },
            {
                text: "本周",
                value: () => {
                    const now = new Date();
                    const day = now.getDay() || 7;
                    const start = new Date(now.getTime() - (day - 1) * 24 * 60 * 60 * 1000);
                    return [start, now];
                },
            },
            {
                text: "本月",
                value: () => {
                    const now = new Date();
                    const start = new Date(now.getFullYear(), now.getMonth(), 1);
                    return [start, now];
                },
            },
            {
                text: "半年",
                value: () => {
                    const now = new Date();
                    const start = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
                    return [start, now];
                },
            },
        ];

        // 监听日期变化 → 自动查询
        watch(
            () => dateValue.value,
            (val) => {
                if (val && val.length === 2) {
                    handleSearch();
                }
            },
            { deep: true }
        );

        // 查询接口
        const handleSearch = async () => {
            if (!mainTempRef.value) return;
            data.tableData = [];

            const params = {
                size: mainTempRef.value.pageSize || 10,
                current: mainTempRef.value.currentPage || 1,
                startDate: dateValue.value[0] || "",
                endDate: dateValue.value[1] || "",
            };

            const res = await apiActualRevenue(params).catch(() => []);
            mainTempRef.value.setTotalValue(res?.length || 0);
            data.tableData = res || [];
        };

        // 子组件方法
        const handleAddOwner = () => {
            data.currentData = { userType: 1 };
            AddEditUserRef.value?.handleToggle(true);
        };
        const handleAddWasher = () => {
            data.currentData = { userType: 2 };
            AddEditUserRef.value?.handleToggle(true);
        };

        const handleUpdateTable = () => handleSearch();
        provide("handleUpdateTable", handleUpdateTable);
        provide("handleSearch", handleSearch);

        // 初始化
        onMounted(() => {
            handleSearch();
        });

        return {
            dateValue,
            shortcuts,
            AddEditUserRef,
            handleAddWasher,
            handleAddOwner,
            mainTempRef,
            data,
            handleSearch,
        };
    },
};
</script>

<style scoped>
</style>
